import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axiosConfig';

// Acciones asíncronas
export const fetchEmployees = createAsyncThunk(
    'employees/fetchEmployees',
    async ( slug, _, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/${slug}/api/employees`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

export const addEmployee = createAsyncThunk(
    'employees/addEmployee',
    async ( slug, employeeData, { rejectWithValue }) => {
        try {
            const response = await axios.post(`/${slug}/api/employees`, employeeData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data || error.message);
        }
    }
);

// Puedes agregar más acciones para editar y eliminar empleados

const employeeSlice = createSlice({
    name: 'employees',
    initialState: {
        employees: [],
        loading: false,
        error: null,
    },
    reducers: {
        // Reducers síncronos si los necesitas
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployees.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmployees.fulfilled, (state, action) => {
                state.employees = action.payload;
                state.loading = false;
            })
            .addCase(fetchEmployees.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(addEmployee.fulfilled, (state, action) => {
                state.employees.push(action.payload);
            });
        // Agrega casos para otras acciones si es necesario
    },
});

export default employeeSlice.reducer;
